<section class="py-20 bg-gradient-to-b from-white to-gray-50 overflow-hidden font-sans">
  <div class="max-w-7xl mx-auto px-6 text-center">

    <div class="mb-14 space-y-3">
        <h2 class="text-4xl md:text-5xl font-black text-[#002670] leading-tight">
            স্কুল ম্যানেজমেন্ট সফটওয়্যার নয়,<span class="text-transparent bg-clip-text bg-gradient-to-r from-[#4247a1] to-[#3368fa] relative"> চাই রাইট সিস্টেম
              <span class="absolute -bottom-2 left-0 w-full h-1 bg-orange-400 rounded-full opacity-70"></span>
            </span>
        </h2>

    </div>

    <div class="relative max-w-4xl mx-auto group cursor-pointer" (click)="toggleVideo()">

      <div class="absolute -inset-1 bg-gradient-to-r from-[#4247a1] to-[#3368fa] rounded-[2rem] blur opacity-10 group-hover:opacity-25 transition duration-1000"></div>

      <div class="relative rounded-[2rem] overflow-hidden border-[6px] border-white shadow-2xl transition-all duration-500 transform group-hover:translate-y-[-5px]">

        <img loading="lazy" src="thumbnail.jpg.jpeg" class="w-full h-auto object-cover group-hover:scale-110 transition-transform duration-1000 max-h-[350px] md:max-h-[480px]" alt="Thumbnail" />

        <div class="absolute top-4 left-4 bg-white/20 backdrop-blur-md border border-white/30 px-4 py-2 rounded-full hidden md:flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-[-10px] group-hover:translate-y-0">
            <span class="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
            <span class="text-white text-xs font-bold uppercase tracking-wider">Demo Video</span>
        </div>

        <div class="absolute inset-0 flex items-center justify-center bg-[#001233]/10 group-hover:bg-[#001233]/20 transition-all duration-500">
          <div class="relative">
            <div class="play-ripple-wave absolute bg-white/40 rounded-full"></div>
            <div class="play-ripple-wave-2 absolute bg-white/20 rounded-full"></div>

            <div class="w-20 h-20 md:w-24 md:h-24 rounded-full flex items-center justify-center shadow-2xl z-20 transition-all duration-300 group-hover:scale-110"
                 style="background: linear-gradient(135deg, #4247a1, #3368fa, #1e2171);">
              <i class="fa-solid fa-play text-white text-3xl md:text-4xl ml-1"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (isVideoOpen) {
    <div class="fixed inset-0 z-[1000] flex items-center justify-center p-4 md:p-10">
      <div class="absolute inset-0 bg-[#001233]/95 backdrop-blur-xl animate-fade-in" (click)="toggleVideo()"></div>

      <button (click)="toggleVideo()" class="absolute top-6 right-6 md:top-10 md:right-10 w-12 h-12 bg-white/10 hover:bg-red-500 text-white rounded-full flex items-center justify-center z-[1001] transition-all hover:rotate-90 border border-white/10">
        <i class="fa-solid fa-xmark text-2xl"></i>
      </button>

      <div class="relative w-full max-w-5xl bg-black rounded-3xl overflow-hidden shadow-[0_0_100px_rgba(0,0,0,0.5)] z-[1001] animate-modal-zoom aspect-video">
        <div id="player" data-plyr-provider="youtube" [attr.data-plyr-embed-id]="youtubeVideoId"></div>
      </div>
    </div>
  }
</section>
